import { render } from "./DictionaryColorForm.vue?vue&type=template&id=4434a200"
import script from "./DictionaryColorForm.vue?vue&type=script&lang=js"
export * from "./DictionaryColorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__